<template>
  <v-form v-model="valid">
    <v-container fluid class="mb-10">
      <v-row justify="center">
        <v-col cols="12" md="2" sm="6">
          <v-card class="mx-auto" tile elevation="1" outlined>
            <v-list dense disabled>
              <v-list-item>
                <v-list-item-icon class="mr-3">
                  <v-icon>mdi-robot</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="mt-1">
                  {{ $store.state.store.store.store_name }}
                </v-list-item-title>
              </v-list-item>
              <v-list-group
                v-model="item"
                no-action
                value="true"
                append-icon=""
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon size="20" class="ml-3">
                        mdi-chevron-right
                      </v-icon>
                      {{ $t("llm_config.title") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-group>
            </v-list>
            <v-row dense no-gutters align="center">
              <v-col class="text-center">
                <v-btn
                  class="mb-2 pa-1"
                  color="success"
                  elevation="1"
                  :disabled="!valid"
                  :dark="valid"
                  @click="handleUpdate()"
                  :small="$vuetify.breakpoint.mdAndUp"
                >
                  <v-icon :small="$vuetify.breakpoint.mdAndUp" class="mr-1">
                    mdi-check-outline
                  </v-icon>
                  {{ $t("store.update") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>

          <v-select
            v-model="selectCancelValue"
            label="Openai Config"
            :items="[
              { text: 'OFF', value: false },
              { text: 'ON', value: true },
            ]"
            variant="solo-inverted"
            @change="setSelected"
          ></v-select>
        </v-col>

        <v-col cols="12" md="10" sm="12">
          <v-card
            :loading="loading"
            elevation="0"
            v-if="openaiConfig && !loading"
            class="pa-2"
          >
            <v-row justify="center" align="center">
              <v-col
                v-if="this.$store.state.access_openai_config == true"
                cols="12"
              >
                <ai-config
                  :openaiConfig="openaiConfig"
                  :form_roles="form_roles"
                />
              </v-col>
              <v-col
                v-if="this.$store.state.access_openai_config == true"
                cols="12"
              >
                <escalation-manager
                  :openaiConfig="openaiConfig"
                  :form_roles="form_roles"
                />
              </v-col>
              <v-col
                v-if="this.$store.state.access_openai_config == true"
                cols="12"
              >
                <langage-agent-config
                  :openaiConfig="openaiConfig"
                  :form_roles="form_roles"
                />
              </v-col>
              <v-col
                v-if="this.$store.state.access_openai_config == true"
                cols="12"
              >
                <number-of-chunks-analyzed
                  :openaiConfig="openaiConfig"
                  :form_roles="form_roles"
                />
              </v-col>
              <v-col
                v-if="this.$store.state.access_openai_config == true"
                cols="12"
              >
                <lang-chain-config
                  :openaiConfig="openaiConfig"
                  :form_roles="form_roles"
                  :openaiModels="openaiModels"
                />
              </v-col>

              <v-col
                v-if="this.$store.state.access_openai_config == true"
                cols="12"
              >
                <index-parameters
                  :openaiConfig="openaiConfig"
                  :form_roles="form_roles"
                  @emitLoading="loading = $event"
                />
              </v-col>
              <v-col cols="12">
                <client-description
                  :openaiConfig="openaiConfig"
                  :form_roles="form_roles"
                />
              </v-col>
            </v-row>
          </v-card>
          <v-progress-linear
            color="#1a4dcd"
            :active="loading"
            :indeterminate="loading"
            rounded
            height="4"
          >
          </v-progress-linear>
        </v-col>
      </v-row>
      <v-dialog v-model="dialog" max-width="400">
        <v-card>
          <v-card-title
            >{{ $t("llm_config.connection_required") }}
          </v-card-title>
          <v-card-text>
            <v-text-field v-model="username" label="Username"></v-text-field>
            <v-text-field
              v-model="password"
              :label="$t('llm_config.password')"
              type="password"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="cancelDialog">{{
              $t("show_box.cancel")
            }}</v-btn>
            <v-btn text @click="submitCredentials">{{
              $t("analytics.btns.start")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-form>
</template>

<script>
import AIConfig from "../components/llm-config/AIConfig.vue";
import IndexParameters from "../components/llm-config/IndexParameters.vue";
import LangChainConfig from "../components/llm-config/LangChainConfig.vue";
import ClientDescription from "../components/llm-config/ClientDescription.vue";
import NumberOfChunksAnalyzed from "../components/llm-config/numberOfChunksAnalyzed.vue";
import EscalationManager from "../components/llm-config/EscalationManager.vue";
import LangageAgentConfig from "../components/llm-config/LangageAgentConfig.vue";

export default {
  name: "LlmConfig",
  components: {
    "ai-config": AIConfig,
    "lang-chain-config": LangChainConfig,
    "index-parameters": IndexParameters,
    "client-description": ClientDescription,
    "number-of-chunks-analyzed": NumberOfChunksAnalyzed,
    "escalation-manager": EscalationManager,
    "langage-agent-config": LangageAgentConfig,
  },
  data: () => ({
    valid: true,
    item: 1,
    loading: true,
    form_roles: {
      optionalField: [
        (value) => {
          if (value) return true;
          return true;
        },
      ],
      text: [
        (value) => {
          if (value) return true;
          return "field is required.";
        },
      ],
      number: [
        (value) => {
          if (value) return true;
          return "field is required.";
        },
        (value) => {
          if (/^\d+$/.test(value)) return true;
          return "Must be a number";
        },
      ],
      booleanField: [
        (value) => {
          if (typeof value === "boolean") return true;
          return "field is required.";
        },
      ],
    },
    dialog: false,
    username: "",
    password: "",
    selectCancelValue: false,
    openaiModels: [],
    llmCollections: [],
  }),
  mounted() {
    this.selectCancelValue = this.$store.state.access_openai_config;
  },
  computed: {
    staging_env() {
      return (
        this.openaiConfig.langchain_settings?.endpoint ==
          "https://test-langchain.cleed.ai/rag_streaming" ||
        this.openaiConfig.langchain_settings?.endpoint ==
          "https://staging-langchain.cleed.ai/rag_streaming"
      );
    },
    openaiConfig() {
      const data = this.$store.state.llm_config.config;
      console.log("openaiConfig", data);
      return data;
    },
  },
  async created() {
    try {
      this.loading = true;
      await this.$store.dispatch("FETCH_LLM_CONFIG");
      this.openaiModels = await this.$store.dispatch("FETCH_OPEN_AI_MODELS");
      this.loading = false;
    } catch (e) {
      console.log(e);
      this.$store.dispatch("setSnackbar", {
        showing: true,
        text: `There is an error ${e.message}`,
        color: "error",
      });
      this.loading = false;
    }
  },
  methods: {
    async handleUpdate() {
      this.$store
        .dispatch("confirmer/ask", {
          title: this.$t("show_box.title"),
          body: "Agree to change",
        })
        .then((confirmation) => {
          if (confirmation) {
            this.save();
          }
        });
    },
    async save() {
      const config = { ...this.openaiConfig };
      try {
        this.loading = true;
        await this.$store.dispatch("UPDATE_OPEN_AI_CONFIG", {
          config: config,
        });
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: "Change added",
          color: "success",
        });
        this.loading = false;
      } catch (e) {
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: "There is an error please contact the administrator",
          color: "error",
        });
        this.loading = false;
      }
    },
    async setSelected(value) {
      if (value) {
        this.dialog = true;
        await this.$store.dispatch("updateAccessOpenaiConfig", {
          value: false,
        });
      } else {
        this.dialog = false;
        await this.$store.dispatch("updateAccessOpenaiConfig", {
          value: false,
        });
      }
      return value;
    },

    // Méthode pour annuler la sélection
    async cancelDialog() {
      await this.setSelected(false);
      this.selectCancelValue = false;
    },

    async submitCredentials() {
      if (this.username && this.password) {
        this.$socket.emit(
          "AccessOpenaiConfig",
          {
            store_id: this.$store.state.store.store.store_id,
            username: this.username,
            password: this.password,
          },
          async (response) => {
            if (response.success) {
              const test = await this.$store.dispatch(
                "updateAccessOpenaiConfig",
                { value: true }
              );
            } else {
              alert("Invalid credentials");
              await this.$store.dispatch("updateAccessOpenaiConfig", {
                value: false,
              });
            }
          }
        );
        this.dialog = false;
      } else {
        alert("Please enter your credentials");
      }
    },
  },
};
</script>
